<template>
  <div>
    <el-dialog
      title="保存模板"
      :visible.sync="templateConfig.is_show"
      width="300px"
      append-to-body
      :close-on-press-escape="false"
      :close-on-click-modal="false"
    >
      <el-input v-model="templateConfig.name" placeholder="请输入模板名称" size="mini" />
      <span slot="footer" class="dialog-footer">
        <el-button @click="templateConfig.is_show = false">取 消</el-button>
        <el-button v-if="templateConfig.is_validate" type="primary" @click="confirm">确 定</el-button>
        <el-popconfirm
          v-else
          title="有必填项未填，是否确定保存为模板？"
          @confirm="confirm"
        >
          <el-button slot="reference" type="primary" style="margin-left: 10px;">确 定</el-button>
        </el-popconfirm>

      </span>
    </el-dialog>
  </div>
</template>

<script>
export default {
  props: {
    /** 模板弹框配置 */
    templateConfig: {
      type: Object,
      default: null,
    },
  },
  methods: {
    confirm(){
      this.$emit('confirm');
    },
  },
};
</script>
